import React, { useState, useRef } from 'react';

export default function ScreenshotCarousel({ screenshots }) {
  const [imagesLoaded, setImagesLoaded] = useState({});
  const carouselRef = useRef(null);

  const handleImageLoad = (index) => {
    setImagesLoaded(prev => ({ ...prev, [index]: true }));
  };

  if (!screenshots || screenshots.length === 0) {
    return null;
  }

  return (
    <div style={{
      width: '100%',
      minHeight: 'calc(100vh - 200px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 0',
      backgroundColor: '#0a0a0a',
    }}>
      <div style={{ width: '100%' }}>
        {/* Desktop: All images in a row */}
        <div style={{
          display: 'none',
          gap: '24px',
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: '1400px',
          margin: '0 auto',
        }}
        className="desktop-screenshots"
        >
          {screenshots.map((url, index) => (
            <div
              key={index}
              style={{
                flex: '0 0 auto',
                width: '240px',
                aspectRatio: '9/19.5',
                backgroundColor: '#2a2a2a',
                borderRadius: '32px',
                overflow: 'hidden',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
              }}
            >
              <img
                src={url}
                alt={`Screenshot ${index + 1}`}
                onLoad={() => handleImageLoad(index)}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  opacity: imagesLoaded[index] ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                }}
              />
            </div>
          ))}
        </div>

        {/* Mobile: Carousel with dots */}
        <div className="mobile-screenshots" style={{ position: 'relative', height: '100%' }}>
        <div
          ref={carouselRef}
          style={{
            display: 'flex',
            overflowX: 'auto',
            scrollSnapType: 'x mandatory',
            gap: '16px',
            padding: '24px',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            WebkitOverflowScrolling: 'touch',
            height: '100%',
            alignItems: 'center',
          }}
        >
          {screenshots.map((url, index) => (
            <div
              key={index}
              style={{
                flex: '0 0 80%',
                maxWidth: '300px',
                aspectRatio: '9/19.5',
                backgroundColor: '#2a2a2a',
                borderRadius: '32px',
                overflow: 'hidden',
                scrollSnapAlign: 'center',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
              }}
            >
              <img
                src={url}
                alt={`Screenshot ${index + 1}`}
                onLoad={() => handleImageLoad(index)}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  opacity: imagesLoaded[index] ? 1 : 0,
                  transition: 'opacity 0.3s ease',
                }}
              />
            </div>
          ))}
        </div>
      </div>

        <style>
          {`
            @media (min-width: 1024px) {
              .desktop-screenshots {
                display: flex !important;
              }
              .mobile-screenshots {
                display: none !important;
              }
            }
            .mobile-screenshots > div::-webkit-scrollbar {
              display: none;
            }
          `}
        </style>
      </div>
    </div>
  );
}
